import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import { Button, Icon } from '@saviynt/design-system';

import { TAB_STATUS_ALL } from '../../../components/ViewControls';
import {
  getCertDetailsForExport,
  performCertsExport,
} from '../../../redux/certdetails/action';
import {
  SCREEN_SIZE_TABLET_SMALL,
  SCREEN_WIDTH_QUERIES,
} from '../../../utils/constant';
import { getMessageKey } from '../../../utils/utils';

import CertsExportModal from './CertsExportModal';

function CertsExport() {
  const intl = useIntl();
  const dispatch = useDispatch();

  const [isExportModalOpen, setIsExportModalOpen] = useState(false);

  const { messages } = useSelector((state) => state?.user);

  const {
    global: { certKey, mediaQueryValue, columnNames, searchText } = {},
    tabs: { tabData } = {},
  } = useSelector((state) => state?.certifications?.details || {});

  const allTabCount = tabData?.find((tab) => tab.key === TAB_STATUS_ALL)?.count;
  const shouldDisableExportBtn = Boolean(allTabCount === 0);

  const tabletSmallQuery = SCREEN_WIDTH_QUERIES.find(
    (item) => item.label === SCREEN_SIZE_TABLET_SMALL
  );
  const isTabletWidth = tabletSmallQuery.value > mediaQueryValue;

  const isLegacyExport = false;
  let onExportButtonClick;

  if (isLegacyExport) {
    onExportButtonClick = () => {
      dispatch(performCertsExport(certKey));
    };
  } else {
    onExportButtonClick = () => {
      setIsExportModalOpen(true);
      dispatch(
        getCertDetailsForExport(certKey, columnNames, 10, 0, searchText)
      );
    };
  }

  return (
    <div className='CertsExport'>
      <Button
        type='button'
        kind={shouldDisableExportBtn ? 'filled' : 'outlined'}
        size='medium'
        isDisabled={shouldDisableExportBtn}
        onClick={() => onExportButtonClick()}
        ariaLabel={
          messages.CERTS_EXPORT || localize(intl, getMessageKey('CERTS_EXPORT'))
        }
        className={shouldDisableExportBtn ? '' : 'CertsHeader-button'}
        leftIcon={
          <Icon
            kind='Export'
            size='smallMedium'
            ariaLabel={
              messages.CERTS_EXPORT ||
              localize(intl, getMessageKey('CERTS_EXPORT'))
            }
          />
        }>
        {isTabletWidth
          ? messages.CERTS_EXPORT ||
            localize(intl, getMessageKey('CERTS_EXPORT'))
          : ''}
      </Button>
      {isExportModalOpen && (
        <CertsExportModal
          isOpen={isExportModalOpen}
          setIsOpen={setIsExportModalOpen}
        />
      )}
    </div>
  );
}

export default CertsExport;
